"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCertifiedPopOverWithClassName = exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _Popover = _interopRequireDefault(require("angieslist-react-components/lib/Popover"));

var _strong, _p, _small;

var getCertifiedPopOverWithClassName = function getCertifiedPopOverWithClassName() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'certified-popover';
  return /*#__PURE__*/(0, _jsx2.default)(_Popover.default, {
    id: "popover-certified-badge",
    className: className
  }, void 0, /*#__PURE__*/(0, _jsx2.default)("p", {
    style: {
      marginTop: 10
    }
  }, void 0, _strong || (_strong = /*#__PURE__*/(0, _jsx2.default)("strong", {}, void 0, "Angi Certified Businesses"))), _p || (_p = /*#__PURE__*/(0, _jsx2.default)("p", {}, void 0, 'These Businesses meet our standards of certification, which include:')), _small || (_small = /*#__PURE__*/(0, _jsx2.default)("small", {}, void 0, /*#__PURE__*/(0, _jsx2.default)("ul", {}, void 0, /*#__PURE__*/(0, _jsx2.default)("li", {}, void 0, "The owner, principal, or relevant manager passing a criminal background check"), /*#__PURE__*/(0, _jsx2.default)("li", {}, void 0, "Required to have applicable state and local licenses"), /*#__PURE__*/(0, _jsx2.default)("li", {}, void 0, "Maintain an average star rating of 3.0 or better on our network, if they have at least one review"), /*#__PURE__*/(0, _jsx2.default)("li", {}, void 0, "Paying to advertise their services"), /*#__PURE__*/(0, _jsx2.default)("li", {}, void 0, "Meeting any other eligibility criteria required by Angi ")))));
};

exports.getCertifiedPopOverWithClassName = getCertifiedPopOverWithClassName;

var _default = getCertifiedPopOverWithClassName();

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/certifiedBadgePopOver/CertifiedPopOver.js
// module id = 3165
// module chunks = 25